<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <el-input class="search_input search_inputBox" v-model="params.name" placeholder="开证公司"
                    size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.linkman" placeholder="联系人"
                    @visible-change="getSelectList('linkman')">
                    <el-option v-for="(list,index) in selectMap.linkman" :key="index" :value="list.id"
                        :label="list.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.phone" placeholder="联系电话"
                    size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.email" placeholder="电子邮箱"
                    size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.remark" placeholder="备注"
                    size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" v-if="module.indexOf(',customer-export,')!=-1" @click="exportExcelBill"><i
                            class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',customer-add,')!=-1"
                    @click="openAddIssue()">新增开证公司</el-button>
                <!-- <el-button class="funcPublicBtn" @click="uploadFile">上传文件</el-button> -->
                <div class="upimgBtnBox" v-if="module.indexOf(',purchase-upload-files,')!=-1" @click="uploadFile">
                    <div class="upFileBtnImg"></div>
                    <div class="upimgBtnTitle">上传文件</div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="issuing.list" :isLoading="tableLoading" :tablecol="tableCol"
                    :tabledata="list" @getRow="selectChange" @rowClick="rowClick" @getTableEdit="edit"
                    @getTableDelete="del"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page"
                    :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <el-dialog v-dialog-drag :title="updataType==3?'修改开证公司':updataType==2?'新增开证公司':'开证公司'"
            class="eldialog eldialogA" :visible.sync="dialogVisible" :model="false" custom-class="full_dialog">
            <div class="">
                <el-form :model="form_params" :rules="rules" ref="edit_form"
                    style="overflow-y: auto;max-height: 600px;">
                    <!-- <div class="dialog_path_title eldialogFormTag">基本信息</div> -->
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="公司全称：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司简称：" prop="short_name">
                            <el-input class="edit_input" v-model="form_params.short_name" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人：" prop="linkman">
                            <el-input class="edit_input" v-model="form_params.linkman" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                            <el-input class="edit_input" v-model="form_params.phone" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮件：" prop="email">
                            <el-input class="edit_input" v-model="form_params.email" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司主营：" prop="business_category">
                            <el-input class="edit_input" v-model="form_params.business_category" placeholder=""
                                :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <div class="mark">
                            <el-form-item label="备注信息：" prop="remark">
                                <div class="content_box">
                                    <span class="content">{{form_params.remark}}</span>
                                    <span class="edit cursorPointer" @click="markEdit"></span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">融资利率设置</div>
                    <template v-for="(item,index) in form_params.finance_rate_config">
                        <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="天数范围：" :prop="`finance_rate_config[${index}].start_day`"
                                    :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <!-- <el-input v-model="item.contact" class="edit_input" ></el-input> -->
                                    <el-col :span="11">
                                        <el-input v-model="item.start_day" class="edit_input"
                                            @input.native="changeaddAmounta($event,item.start_day)"
                                            :disabled="isSeeEdit"></el-input>
                                    </el-col>
                                    <el-col class="line" style="width:10px" :span="2">-</el-col>
                                    <el-col :span="11">
                                        <el-input v-model="item.end_day" class="edit_input"
                                            @input.native="changeaddAmounta($event,item.end_day)"
                                            :disabled="isSeeEdit"></el-input>
                                    </el-col>
                                </el-form-item>
                                <el-form-item label="计算利率：" :prop="`finance_rate_config[${index}].rate`"
                                    :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.rate" class="edit_input" :disabled="isSeeEdit">
                                        <template slot="suffix"><span class="sizefh">‰</span></template>
                                    </el-input>
                                    <!-- <span style="position: absolute;right: 5px;font-size: 12px;">‰</span> -->
                                </el-form-item>
                            </div>
                            <div v-if="isSeeEdit==false"
                                :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"
                                @click="addOrDelete(index)"></div>
                        </div>
                    </template>
                    <div class="dialog_path_title eldialogFormTag">融资费率设置</div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="代理费用：" prop="remark">
                                <span class="content">进口发票金额*付汇当日汇率*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="agent.rate"
                                        @input.native="changeaddAmounta($event,agent.rate)" placeholder=""
                                        :disabled="isSeeEdit">
                                        <template slot="suffix"><span class="sizefh">‰</span></template>
                                    </el-input>
                                </div>
                                <span>*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="agent.tax"
                                        @input.native="changeaddAmounta($event,agent.rate)" placeholder="含税值"
                                        :disabled="isSeeEdit">
                                    </el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClickTwo(agent.status,1):''"
                                :class="['tableStatus',agent.status==1?'tableStatusChecked':'']">
                                {{agent.status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="银行费用：" prop="remark">
                                <span class="content">进口发票金额*付汇当日汇率*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="bank.rate"
                                        @input.native="changeaddAmounta($event,bank.rate)" placeholder=""
                                        :disabled="isSeeEdit">
                                        <template slot="suffix"><span class="sizefh">‰</span></template>
                                    </el-input>
                                </div>
                                <!-- <span style="position: relative;right: 20px;">‰</span> -->
                                <span>+</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="bank.cable"
                                        @input.native="changeaddAmounta($event,bank.cable)" placeholder="电报费"
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                                <!-- <span>*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="bank.tax"
                                        @input.native="changeaddAmounta($event,bank.cable)" placeholder="含税值"
                                        :disabled="isSeeEdit"></el-input>
                                </div> -->
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClickTwo(bank.status,2):''"
                                :class="['tableStatus',bank.status==1?'tableStatusChecked':'']">
                                {{bank.status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="手续费：" prop="remark">
                                <span class="content">不足</span>
                             
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="fee.first_fee_a"
                                         placeholder=""
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                                <span class="content">按</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="fee.first_fee_b"
                                         placeholder=""
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                                <span>，</span>
                                <span class="content">超过</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="fee.two_fee_a"
                                         placeholder=""
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                                <span class="content">按</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="fee.two_fee_b"
                                         placeholder=""
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClickTwo(fee.status,4):''"
                                :class="['tableStatus',fee.status==1?'tableStatusChecked':'']">
                                {{fee.status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="保险费用：" prop="remark">
                                <span class="content">进口发票金额*付汇当日汇率*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="insure.rate" placeholder=""
                                        :disabled="isSeeEdit"></el-input>
                                </div>
                                <span>*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="insure.single_rate" placeholder=""
                                        :disabled="isSeeEdit">
                                        <template slot="suffix"><span class="sizefh">‰</span></template>
                                    </el-input>
                                </div>
                                <span>*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="insure.tax"
                                        @input.native="changeaddAmounta($event,agent.rate)" placeholder="含税值"
                                        :disabled="isSeeEdit">
                                    </el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClickTwo(insure.status,3):''"
                                :class="['tableStatus',insure.status==1?'tableStatusChecked':'']">
                                {{insure.status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="押汇利息：" prop="remark">
                                <span class="content">进口发票金额*付汇当日汇率*4‰*90/365</span>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">融资类型保证金比例设置</div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="L/C(信用证)：" prop="remark">
                                <span class="content">保证金比例*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="form_params.lc_deposit_rate" placeholder=""
                                        :disabled="isSeeEdit"
                                        @input.native="changeaddRate($event,form_params.lc_deposit_rate)">
                                        <template slot="suffix"><span class="sizefh">%</span></template>
                                    </el-input>
                                </div>
                                <!-- <span style="position: relative;right: 15px;font-size: 12px;">%</span> -->
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClick(form_params.lc_deposit_status,1):''"
                                :class="['tableStatus',form_params.lc_deposit_status==1?'tableStatusChecked':'']">
                                {{form_params.lc_deposit_status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="T/T(电汇)：" prop="remark">
                                <span class="content">保证金比例*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="form_params.tt_deposit_rate" placeholder=""
                                        :disabled="isSeeEdit"
                                        @input.native="changeaddtt_deposit_rate($event,form_params.tt_deposit_rate)">
                                        <template slot="suffix"><span class="sizefh">%</span></template>
                                    </el-input>
                                </div>
                                <!-- <span style="position: relative;right: 15px;font-size: 12px;">%</span> -->
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClick(form_params.tt_deposit_status,2):''"
                                :class="['tableStatus',form_params.tt_deposit_status==1?'tableStatusChecked':'']">
                                {{form_params.tt_deposit_status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                    <div class="eldialogFormBox clearfix" style="position: relative;">
                        <div class="agencyFee">
                            <el-form-item label="D/P(托收)：" prop="remark">
                                <span class="content">保证金比例*</span>
                                <div class="content_box">
                                    <el-input class="edit_input" v-model="form_params.dp_deposit_rate" placeholder=""
                                        :disabled="isSeeEdit"
                                        @input.native="changeadddp_deposit_rate($event,form_params.dp_deposit_rate)">
                                        <template slot="suffix"><span class="sizefh">%</span></template>
                                    </el-input>
                                </div>
                                <!-- <span style="position: relative;right: 15px;font-size: 12px;">%</span> -->
                            </el-form-item>
                        </div>
                        <div class="cell">
                            <div @click="isSeeEdit==false?statusClick(form_params.dp_deposit_status,3):''"
                                :class="['tableStatus',form_params.dp_deposit_status==1?'tableStatusChecked':'']">
                                {{form_params.dp_deposit_status==1?'开启':'禁用'}}</div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" v-if="isSeeEdit==false" @click="addIssue">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 上传文件 -->
        <el-dialog v-dialog-drag title="上传文件" :visible.sync="importFiles" class="eldialog eldialogA" :modal="false"
            width='500px'>
            <div class="text-center" style="margin-top:20px;">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data"
                    :on-success="handleSuccess" :before-upload="beforeUpload"
                    accept=".xls,.xlsx,.txt,image/jpeg,image/png">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" style="font-size:12px; color:#333;">将文件拖到此处，或<em
                            style="color: #b21111;">点击上传</em></div>
                </el-upload>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="filesYes">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importFiles=!importFiles">取消</el-button>
            </div>
        </el-dialog>
        <!-- 备注 sTART-->
        <el-dialog title="备注" :visible.sync="markDialogVisible" class="eldialog mark_dialog" width="350px"
            :modal="false" :before-close="markhandleClose" v-dialogDrag>
            <div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark"
                    :disabled="isSeeEdit"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small"
                    @click="markDialogVisible=false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 备注 END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="issuing.list" :filterDialogVisible="filterDialogVisible"
            @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title {
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        line-height: 25px;
        color: #606266;
        padding-bottom: 20px;
        background-color: #fff;
    }

    .search_box {
        padding-right: 230px;
    }

    .execlInsert .excel_btn {
        display: inline;
    }

    .link_item {
        // padding-right: 50px;
        // margin:0 37px;      
        // margin-top:20px;
        position: relative;

        .item_icon {
            position: absolute;
            right: 0px;
            top: 4px;
            display: block;
            width: 25px;
            height: 25px;
        }

        .add_icon {
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
        }

        .del_icon {
            background: url(/icon/frame_minus.png) center center no-repeat;
            background-size: 16px 16px;
        }
    }

    .add_item {
        border-top: 1px dashed #aaa;
        margin-top: 0px;
        padding-top: 10px;
    }

    .file {
        width: 20px;
        float: left;
        margin-left: 5px;
        margin-top: 1px;
    }

    .mark {
        .content_box {
            width: 140px;
            border-bottom: 1px solid #DCDFE6;
            display: flex;
            padding-left: 10px;
            font-size: 12px;

            .content {
                flex: 1;
                display: inline-block;
                width: 120px;
                height: 24px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
            }

            .edit {
                display: inline-block;
                width: 20px;
                background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                background-size: 16px 16px;
            }
        }
    }

    .agencyFee {
        .content_box {
            width: 80px;
            display: flex;
        }
    }

    .cell {
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-all;
        line-height: 23px;
        padding-left: 10px;
    }

    .content {
        font-size: 12px;
    }

    .tableStatus {
        background: #f2f2ff;
        color: #b21111;
        padding: 1px 10px;
        border-radius: 3px;
        text-align: center;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
    }

    .tableStatusChecked {
        background: #F9A602;
        color: #fff;
    }

    .sizefh {
        font-size: 12px;
    }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components: {
            pagination,
            tabletem
        },
        data() {
            return {
                tableLoading: false,
                module: localStorage.dw_erp_power_code,
                //导入 start
                upload_data: {},
                oss: {
                    host: "",
                },
                file_url: '',
                //导入 end
                selectList: [],
                ruleForm: {
                    ids: [],
                    salesman_id: ""
                },
                params: {
                    name: "",
                    linkman: "",
                    phone: "",
                    email: "",
                    remark: "",
                    per_page: 50,
                    page: 1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType: 2,//2新增，3修改
                list: [],
                proList: [],
                cityList: [],
                cityListS: [],
                selectMap: {
                    linkman: [],
                    customerSource: [],
                    customerAttribute: []
                },
                selectDialogVisible: false,
                // dialog START
                dialogVisible: false,
                filterDialogVisible: false,
                filter: "",
                fields: "",
                form_params: {
                    id: "",
                    name: "",
                    short_name: "",
                    linkman: "",
                    phone: "",
                    email: '',
                    business_category: '',
                    address: '',
                    remark: '',
                    finance_rate_config: [
                        { start_day: '', end_day: '', rate: '' }
                    ],
                    agent_rate_config: {
                        bank: { rate: '', cable: '' },
                        agent: { rate: '', },
                        insure: { rate: '', single_rate: '' },
                        fee:{ first_fee_a:'',first_fee_b:'',two_fee_a:'',two_fee_b:'',}
                    },
                    lc_deposit_rate: '',
                    lc_deposit_status: 1,
                    tt_deposit_rate: '',
                    tt_deposit_status: 1,
                    dp_deposit_rate: '',
                    dp_deposit_status: 1,
                },
                bank: {
                    rate: '',
                    cable: '',
                    status: 1,
                },
                agent: {
                    rate: '',
                    status: 1,
                },
                fee:{
                    first_fee_a:'',
                    first_fee_b:'',
                    two_fee_a:'',
                    two_fee_b:'',
                    status: 1,
                },
                insure: {
                    rate: '',
                    single_rate: '',
                    status: 1,
                },
                rules: {
                    name: [{ required: true, message: '请输入公司全称', trigger: 'blur' }],
                    short_name: [{ required: true, message: '请输入公司简称', trigger: 'blur' }],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
                tableCol: [
                    { colName: "开证公司全称", colKey: "name", colWidth: 190, isSetWidth: true, isCanClick: true },
                    { colName: "公司简称", colKey: "short_name", colWidth: 110, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "融资设置", colKey: "finance_rate_config", colWidth: 100, isSetWidth: true, isCanClick: true, isColor: true, isHideShowClickImg: true, },
                    { colName: "代理费设置", colKey: "agent_rate_config", colWidth: 100, isSetWidth: true, isCanClick: true, isColor: true, isHideShowClickImg: true, },
                    { colName: "联系人", colKey: "linkman", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "联系电话", colKey: "phone", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "电子邮箱", colKey: "email", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "公司主营", colKey: "business_category", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "公司地址", colKey: "address", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "关联文件", colKey: "files", colWidth: 100, isSetWidth: true, isCanClick: true, isColor: true, isHideShowClickImg: true, },
                    { colName: "录入时间", colKey: "create_time", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "备注", colKey: "remark", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "融资次数", colKey: "finance_count", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "融资余额", colKey: "finance_balance", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "赎货余额", colKey: "account_balance", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "融资利息", colKey: "finance_interest", colWidth: 90, isSetWidth: true, isCanClick: true, isShow: true },
                    { colName: "实付利息", colKey: "pay_interest", colWidth: 90, isSetWidth: true, isCanClick: true, isShow: true },
                    { colName: "状态", colKey: "status_text", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "当前保证金", colKey: "deposit_balance", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: " 赎货余额", colKey: "account_balance", colWidth: 90, isSetWidth: true, isCanClick: false, isShow: true },
                ],
                // dialog END
                // uploadExecl START
                show_upload: false,
                // uploadExecl END
                importFiles: false,
                markDialogVisible: false,
                markDialogVisibles: false,
                markCopy: '',//备注复制
                isSeeEdit: false,
                isShowMore: false,
            }
        },
        created() {
            this.getSelectList("linkman")
            this.getSelectList("customerSource")
            this.getSelectList("customerAttribute")
            this.getArea().then(resolve => {
                this.proList = resolve.data.data;
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods: {
            changeaddRate(e, input) {
                e.target.value = (e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input = e.target.value
                this.form_params.lc_deposit_rate = this.input
            },
            changeaddtt_deposit_rate(e, input) {
                e.target.value = (e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input = e.target.value
                this.form_params.tt_deposit_rate = this.input
            },
            changeadddp_deposit_rate(e, input) {
                e.target.value = (e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input = e.target.value
                this.form_params.dp_deposit_rate = this.input
            },
            changeaddAmounta(e, input) {
                e.target.value = (e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input = e.target.value
                // item.start_day=this.input
            },
            uploadFile() {
                if (this.selectList.length < 1) {
                    this.tip("请选择客户", "warning")
                } else if (this.selectList.length > 1) {
                    this.tip("选择数量不能大于" + 1 + "条", "warning")
                } else {
                    this.importFiles = true
                }
            },
            statusClick(type, num) {
                if (type == this.form_params.lc_deposit_status && num == 1) {
                    if (this.form_params.lc_deposit_status == 1) {
                        this.form_params.lc_deposit_status == 1 ? this.form_params.lc_deposit_status = 0 : '';
                    } else if (this.form_params.lc_deposit_status == 0) {
                        this.form_params.lc_deposit_status == 0 ? this.form_params.lc_deposit_status = 1 : '';
                    }
                }
                if (type == this.form_params.tt_deposit_status && num == 2) {
                    if (this.form_params.tt_deposit_status == 1) {
                        this.form_params.tt_deposit_status == 1 ? this.form_params.tt_deposit_status = 0 : '';
                    } else if (this.form_params.tt_deposit_status == 0) {
                        this.form_params.tt_deposit_status == 0 ? this.form_params.tt_deposit_status = 1 : '';
                    }
                }
                if (type == this.form_params.dp_deposit_status && num == 3) {
                    if (this.form_params.dp_deposit_status == 1) {
                        this.form_params.dp_deposit_status == 1 ? this.form_params.dp_deposit_status = 0 : '';
                    } else if (this.form_params.dp_deposit_status == 0) {
                        this.form_params.dp_deposit_status == 0 ? this.form_params.dp_deposit_status = 1 : '';
                    }
                }
            },
            statusClickTwo(type, num) {
                if (type == this.agent.status && num == 1) {
                    if (this.agent.status == 1) {
                        this.agent.status == 1 ? this.agent.status = 0 : '';
                    } else if (this.agent.status == 0) {
                        this.agent.status == 0 ? this.agent.status = 1 : '';
                    }
                }
                if (type == this.bank.status && num == 2) {
                    if (this.bank.status == 1) {
                        this.bank.status == 1 ? this.bank.status = 0 : '';
                    } else if (this.bank.status == 0) {
                        this.bank.status == 0 ? this.bank.status = 1 : '';
                    }
                }
                if (type == this.insure.status && num == 3) {
                    if (this.insure.status == 1) {
                        this.insure.status == 1 ? this.insure.status = 0 : '';
                    } else if (this.insure.status == 0) {
                        this.insure.status == 0 ? this.insure.status = 1 : '';
                    }
                }
                if (type == this.fee.status && num == 4) {
                    if (this.fee.status == 1) {
                        this.fee.status == 1 ? this.fee.status = 0 : '';
                    } else if (this.fee.status == 0) {
                        this.fee.status == 0 ? this.fee.status = 1 : '';
                    }
                }
            },
            openFile() {
                window.open(this.form_params.files)
            },
            //备注编辑
            markEdit() {
                this.markDialogVisible = true
                this.markCopy = this.form_params.remark
            },
            //备注编辑
            markEdits() {
                this.markDialogVisibles = true
                this.markCopy = this.form_params.remark
            },
            //弹窗关闭回调
            markhandleClose() {
                this.markDialogVisible = false
                this.form_params.remark = this.markCopy
            },
            //弹窗关闭回调
            markhandleCloses() {
                this.markDialogVisibles = false
                this.form_params.remark = this.markCopy
            },
            exportExcelBill() {
                this.$exportExecl("/erp/issuing.export", "开证公司", this.params)
            },
            filterConfirm() {
                this.getList()
            },
            getSelectList(target) {
                // if(target=="user"){
                //     this.$getSelectList(target).then(res=>{
                //         this.selectMap[res.target]=res.data
                //     }) 
                //     return
                // }
                this.$getSelectList(target).then(res => {
                    this.selectMap[res.target] = res.list;
                })
            },
            reset() {
                this.params = this.resetSearch(this.params)
                this.getList()
            },
            //新增表单 多个联系人删除修改
            addOrDelete(index) {
                let newForm = JSON.parse(JSON.stringify(this.form_params))
                if (index == 0) {
                    newForm.finance_rate_config.push({ start_day: '', end_day: '', rate: '' })
                } else {
                    newForm.finance_rate_config.splice(index, 1)
                }
                this.form_params = newForm
            },
            selectChange(row) {
                this.selectList = row;
            },
            distribution() {
                this.ruleForm.ids = [];
                this.selectList.forEach(item => {
                    this.ruleForm.ids.push(item.id)
                })
                this.postFuncLoading("/erp/customer.alloc", this.ruleForm, () => {
                    this.selectDialogVisible = false;
                    this.tip("分配成功", "success")
                    this.getList();
                }, error => {
                    this.tip(error.data.message, "warning")
                })

            },
            del(id) {
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/issuing.delete", { id: id }, () => {
                        this.tip("删除成功", "success")
                        this.getList();
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            openAddIssue() {
                this.updataType = 2
                this.form_params.finance_rate_config = [{ start_day: '', end_day: '', rate: '' }]
                this.dialogVisible = true;
            },
            edit(id) {
                this.dialogVisible = true;
                this.updataType = 3;
                this.form_params.finance_rate_config = [{ start_day: '', end_day: '', rate: '' }]
                this.postFunc('/erp/issuing.info', { id: id }, res => {
                    let resData = res.data.data;
                    this.getArea(res.data.data.province_id).then(resolve => {
                        this.cityList = resolve.data.data;
                        if (res.data.data) {
                            if (res.data.data.agent_rate_config.bank.status == undefined) {
                                res.data.data.agent_rate_config.bank.status = 1;
                            }
                            if (res.data.data.agent_rate_config.agent.status == undefined) {
                                res.data.data.agent_rate_config.agent.status = 1;
                            }
                            if (res.data.data.agent_rate_config.insure.status == undefined) {
                                res.data.data.agent_rate_config.insure.status = 1;
                            }
                        }
                        this.form_params = res.data.data;
                        this.bank = this.form_params.agent_rate_config.bank;
                        this.agent = this.form_params.agent_rate_config.agent;
                        this.insure =this.form_params.agent_rate_config.insure;
                        this.fee = this.form_params.agent_rate_config.fee?this.form_params.agent_rate_config.fee:{first_fee_a:'',
                            first_fee_b:'',
                            two_fee_a:'',
                            two_fee_b:'',
                            status: 1,};
                    })
                })
            },
            rowClick(obj) {
                if (obj.name === 'name') {
                    this.updataType = 4;
                    this.postFunc('/erp/issuing.info', { id: obj.id }, resD => {
                        this.isSeeEdit = true;
                        this.dialogVisible = true;
                        let resData = resD.data.data;
                        this.form_params = resD.data.data;
                        this.bank = this.form_params.agent_rate_config.bank;
                        this.agent = this.form_params.agent_rate_config.agent;
                        this.insure = this.form_params.agent_rate_config.insure;
                        this.fee = this.form_params.agent_rate_config.fee?this.form_params.agent_rate_config.fee:{first_fee_a:'',
                            first_fee_b:'',
                            two_fee_a:'',
                            two_fee_b:'',
                            status: 1,};
                    })
                }
                if(obj.name=='finance_interest'){//融资利息
                    sessionStorage.removeItem("DEMU_ERP_FINANCE_INTEREST_ID")
                    sessionStorage.setItem("DEMU_ERP_FINANCE_INTEREST_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '融资利息'+obj.id,
                        label: '融资利息',
                        content: 'issuseFinanceInterestDetails'
                    });
                }
                if(obj.name=='pay_interest'){//实付利息
                    sessionStorage.removeItem("DEMU_ERP_INTEREST_ID")
                    sessionStorage.setItem("DEMU_ERP_INTEREST_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情'+obj.id,
                        label: '明细详情',
                        content: 'issuseInterestDetails'
                    });
                }
                if (obj.name === 'files') {
                    window.open(obj.row.newFiles)
                }
            },
            getList(flag) {
                if (flag) {
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.$postColumnList("/erp/issuing.list", this.params, res => {
                    this.last_page = parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total = parseInt(res.data.data.data.total);
                    this.list = res.data.data.data.data;
                    this.list.forEach((item, ind) => {
                        item.newFiles = item.files;
                        if (item.files) {
                            item.files = "查看文件";
                        }
                        if (item.finance_rate_config) {
                            item.finance_rate_config = '设置查看'
                        }
                        if (item.agent_rate_config) {
                            item.agent_rate_config = '设置查看'
                        }
                        if (item.create_time) {
                            this.list[ind].create_time = this.formatTime(this.list[ind].create_time + "000")
                            if (localStorage.dw_erp_power_code) {
                                if (localStorage.dw_erp_power_code.indexOf(",customer-edit,") != -1) {
                                    if (item.lock_status == 1) {
                                        item.isEdit = false;
                                    } else {
                                        item.isEdit = true;
                                    }
                                }
                                if (localStorage.dw_erp_power_code.indexOf(",customer-del,") != -1) {
                                    if (item.lock_status == 1) {
                                        item.isDelete = false;
                                    } else {
                                        item.isDelete = true;
                                    }
                                }
                                if (item.lock_status == 1) {
                                    item.isDialogViewlocks = true
                                }
                            }
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields = "," + (res.data.data.fields.join(",")).toString() + ",";
                    this.tableCol.forEach(item => {
                        if (this.fields.indexOf("," + item.colKey + ",") != -1) {
                            item.isShow = true;
                        } else {
                            item.isShow = false;
                        }
                        if (item.colKey == "status_text") {
                            if (this.fields.indexOf(",status,") != -1) {
                                item.isShow = true;
                            }
                        }
                    })
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            changePro(val, type) {
                if (val == '') {
                    if (type == 1) {
                        this.params.city_id = ""
                        this.cityListS = []
                    } else {
                        this.form_params.city_id = ""
                        this.cityList = []
                    }
                    return
                }
                this.getArea(val).then(resolve => {
                    if (type == 1) {
                        this.cityListS = resolve.data.data;
                        this.params.city_id = "";
                    } else {
                        this.cityList = resolve.data.data;
                        this.form_params.city_id = "";
                    }
                })
            },
            addIssue() {
                this.$refs["edit_form"].validate((valid) => {
                    if (valid) {
                        if (this.updataType == 2) {
                            this.form_params.agent_rate_config.bank = this.bank;
                            this.form_params.agent_rate_config.agent = this.agent;
                            this.form_params.agent_rate_config.insure = this.insure;
                            this.form_params.agent_rate_config.fee = this.fee;
                            this.form_params.lc_deposit_rate = Number(this.form_params.lc_deposit_rate);
                            this.form_params.tt_deposit_rate = Number(this.form_params.tt_deposit_rate);
                            this.form_params.dp_deposit_rate = Number(this.form_params.dp_deposit_rate);
                            this.postFuncLoading("/erp/issuing.create", this.form_params, () => {
                                this.tip("添加成功", "success");
                                this.getList();
                                this.form_params = {
                                    id: "", name: "", short_name: "", linkman: "", phone: "", email: '', business_category: '', address: '', remark: '',
                                    finance_rate_config: [
                                        { start_day: '', end_day: '', rate: '' }
                                    ],
                                    agent_rate_config: {
                                        bank: { rate: '', cable: '' },
                                        agent: { rate: '', },
                                        insure: { rate: '', single_rate: '' },
                                        fee:{ffirst_fee_a:'',first_fee_b:'',two_fee_a:'',two_fee_b:'',}
                                    },
                                    lc_deposit_rate: '',
                                    lc_deposit_status: 0,
                                    tt_deposit_rate: '',
                                    tt_deposit_status: 0,
                                    dp_deposit_rate: '',
                                    dp_deposit_status: 0,
                                }
                                //  this.resetJson(this.form_params);
                                this.dialogVisible = false;
                            }, error => {
                                this.tip(error.data.message, "warning");
                            })
                        } else {
                            this.form_params.agent_rate_config.bank = this.bank;
                            this.form_params.agent_rate_config.agent = this.agent;
                            this.form_params.agent_rate_config.insure = this.insure;
                            this.form_params.agent_rate_config.fee = this.fee;
                            this.form_params.lc_deposit_rate = Number(this.form_params.lc_deposit_rate);
                            this.form_params.tt_deposit_rate = Number(this.form_params.tt_deposit_rate);
                            this.form_params.dp_deposit_rate = Number(this.form_params.dp_deposit_rate);
                            this.postFuncLoading("/erp/issuing.update", this.form_params, () => {
                                this.tip("修改成功", "success");
                                this.getList();
                                this.dialogVisible = false;
                            }, error => {
                                this.tip(error.data.message, "warning");
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getPage(obj) {
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },

            //导入 start
            handleSuccess(res) {
                this.file_url = res.data.base_url;
                this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            filesYes() {
                let arr = []
                this.selectList.forEach(item => {
                    arr.push(item.id)
                })
                this.postFunc('/erp/issuing.upload', { ids: arr, files: [this.file_url] }, () => {
                    this.tip("上传成功", "success")
                    this.getList()
                    this.importFiles = false;
                })
            },
            getOss() {
                let self = this;
                return new Promise((resolve, reject) => {
                    window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                        operate_code: "shop-excel"
                    }).then((response) => {
                        if (response.data.code == 0) {
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key: self.oss.dir + "${filename}",
                                policy: self.oss.policy,
                                OSSAccessKeyId: self.oss.accessid,
                                success_action_status: "200",
                                callback: self.oss.callback,
                                signature: self.oss.signature,
                                'Cache-Control': self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(() => {
                        reject();
                    })
                })
            }
            //导入 end
        },
        watch: {
            dialogVisible: function (val) {
                if (!val) {
                    this.isSeeEdit = false
                    this.form_params = {
                        id: "", name: "", short_name: "", linkman: "", phone: "", email: '', business_category: '', address: '', remark: '',
                        finance_rate_config: [
                            { start_day: '', end_day: '', rate: '' }
                        ],
                        agent_rate_config: {
                            bank: { rate: '', cable: '' },
                            agent: { rate: '', },
                            insure: { rate: '', single_rate: '' },
                            fee:{ffirst_fee_a:'',first_fee_b:'',two_fee_a:'',two_fee_b:'',}
                        },
                        lc_deposit_rate: '',
                        lc_deposit_status: 1,
                        tt_deposit_rate: '',
                        tt_deposit_status: 1,
                        dp_deposit_rate: '',
                        dp_deposit_status: 1,
                    }
                    // this.resetJson(this.form_params)
                    this.bank = { rate: '', status: 1, cable: '' }
                    this.agent = { rate: '', status: 1, }
                    this.insure = { rate: '', status: 1, single_rate: '' }
                    this.fee={first_fee_a:'',first_fee_b:'',two_fee_a:'',two_fee_b:'',status: 1}
                }
            },
            "params.page": function () {
                this.getList();
            },
            "params.per_page": function () {
                this.getList();
            },
        }
    }
</script>